import { reactive, ref } from "@vue/composition-api";
import _axios from "@/axios";
import router from "@/router";
import { useHomePage } from "@/composables/home-page";
import global from "@/composables/global";

const { getHomeData } = useHomePage();
const username = ref(localStorage.getItem("userName"));
const openLogoutDialog = ref(false);
const endSessionTimer = ref(0); // nb de minutes avant expiration du token
export function useLogin() {
  let data = reactive({
    userName: "",
    password: "",
    loginError: false,
  });

  function login() {
    return _axios
      .post(config.VUE_APP_AUTH_API_URL, {
        username: data.userName,
        password: data.password,
        application: "wifipass",
      })
      .then((response) => {
        data.loginError = false;
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("userName", data.userName);

        username.value = data.userName;

        const tokenUserPart = atob(response.data.token.split(".")[1]);
        const serverUser = JSON.parse(tokenUserPart);
        const sessionInfos = {
          username: serverUser.userName,
          iat: serverUser.iat,
          exp: serverUser.exp,
        };

        console.log(serverUser.roles);
        console.log(serverUser.roles.wifipass_admin);
        if (
          serverUser.roles.wifipass_admin != null &&
          serverUser.roles.wifipass_admin.length > 0
        ) {
          localStorage.setItem("roles", serverUser.roles.wifipass_admin[0]);
        }

        localStorage.setItem("sessionInfos", JSON.stringify(sessionInfos));
        const nbMinutesTokenValid = (sessionInfos.exp - sessionInfos.iat) / 60;
        const expirationDate = new Date();
        expirationDate.setMinutes(
          expirationDate.getMinutes() + nbMinutesTokenValid
        );
        localStorage.setItem(
          "tokenExpirationDate",
          expirationDate.toISOString()
        );
        getHomeData((apiResult) => {
          global.totalPortals = apiResult.nbPortal;
          global.totalGroups = apiResult.nbGroup;
          global.totalNas = apiResult.nbNas;
        });
        setLogOutWatcher();

        let to = "/";
        if (localStorage.getItem("loginTargetUrl") != null) {
          to = localStorage.getItem("loginTargetUrl");
          localStorage.removeItem("loginTargetUrl");
        }
        router.push(to);
      })
      .catch(() => {
        data.loginError = true;
      });
  }

  function setLogOutWatcher() {
    if (
      localStorage.getItem("sessionTimerId") != null &&
      parseInt(localStorage.getItem("sessionTimerId")) > 0
    ) {
      clearInterval(parseInt(localStorage.getItem("sessionTimerId")));
    }
    const timerId = setInterval(function () {
      const now = Date.now();
      const expirationTime = new Date(
        localStorage.getItem("tokenExpirationDate")
      ).getTime();
      endSessionTimer.value = expirationTime - now;
      // On vérifie toutes les minutes si on est dans les 2h avant expiration du token
      if (!openLogoutDialog.value && endSessionTimer.value <= 120) {
        openLogoutDialog.value = true;
      } else if (endSessionTimer.value <= 0) {
        resetLoginInfos();
      } else {
        openLogoutDialog.value = false;
      }
    }, 1000 * 60);
    localStorage.setItem("sessionTimerId", timerId);
  }

  function resetLoginInfos() {
    localStorage.setItem("lastVisitedUrl", router.currentRoute.path);
    localStorage.removeItem("sessionInfos");
    localStorage.removeItem("token");
    localStorage.setItem("endSessionTimer", 0);
    //clear des intervals en cours d'execution par mesure de précaution
    const interval_id = window.setInterval("", 9999);
    for (let i = 0; i < interval_id; i++) window.clearInterval(i);
  }

  function checkLoginOnLoad() {
    const sessionInfos = localStorage.getItem("sessionInfos") || null;
    let loginValid = true;
    if (sessionInfos && sessionInfos != null) {
      const infos = JSON.parse(sessionInfos);
      if (
        infos.iat > 0 &&
        Date.now() > infos.exp * 1000 &&
        router.currentRoute.path != "/login"
      ) {
        loginValid = false;
      }
    } else {
      loginValid = false;
    }

    return loginValid;
  }

  return {
    data,
    endSessionTimer,
    login,
    username,
    setLogOutWatcher,
    checkLoginOnLoad,
    resetLoginInfos,
    openLogoutDialog,
  };
}
